import { isNil, omitBy } from "@s-libs/micro-dash";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

const useWritePromptResponseGet = (params = {}) => {
  let resource = `${MONOLITH_ORIGIN}/api/v2/constructedresponseanswer/`;
  const queryParams = {
    header_id: params?.headerId,
    student_id: params?.studentId,
    classroom_id: params?.classroomId,
    hide_classroom_id_for_revision: false,
  };

  const queryString = new URLSearchParams(
    omitBy(queryParams, isNil),
  ).toString();
  resource = `${resource}?${queryString}`;
  return useLazyRestQuery(resource, { skip: !params?.headerId });
};

export default useWritePromptResponseGet;
